/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IstitutiCount } from './istituti-count';
import { ComunicazioniCount } from './comunicazioni-count';
import { RegolePunteggioCount } from './regole-punteggio-count';
import { EsercenteCount } from './esercente-count';
import { ServiziCount } from './servizi-count';


export interface TipoPraticaCloneSummaryDTO { 
    policy?: TipoPraticaCloneSummaryDTOPolicyEnum;
    graduatoria?: TipoPraticaCloneSummaryDTOGraduatoriaEnum;
    attributi_count?: number;
    valori_count?: number;
    comunicazioni?: ComunicazioniCount;
    istituti?: IstitutiCount;
    regole_punteggio?: RegolePunteggioCount;
    template_form_cittadino?: TipoPraticaCloneSummaryDTOTemplateFormCittadinoEnum;
    servizi?: ServiziCount;
    esercente?: EsercenteCount;
    articoli_cedole?: number;
    warnings?: Array<string>;
}
export enum TipoPraticaCloneSummaryDTOPolicyEnum {
    CLONED = 'cloned',
    SKIPPED = 'skipped',
    SKIPPED_ORIGIN_EMPTY = 'skipped_origin_empty'
};
export enum TipoPraticaCloneSummaryDTOGraduatoriaEnum {
    CLONED = 'cloned',
    SKIPPED = 'skipped',
    SKIPPED_ORIGIN_EMPTY = 'skipped_origin_empty'
};
export enum TipoPraticaCloneSummaryDTOTemplateFormCittadinoEnum {
    CLONED = 'cloned',
    SKIPPED = 'skipped',
    SKIPPED_ORIGIN_EMPTY = 'skipped_origin_empty'
};



